import React from 'react';
import { Container, Icon, TitleContainer, Subtitle, Title } from './styles';

interface IHomeMenuItemProps {
    icon?: any;
    subtitle?: string;
    title?: string;
    click?: () => void;
    blank?: boolean;
}

const HomeMenuItem: React.FC<IHomeMenuItemProps> = ({
    icon,
    subtitle,
    title,
    click,
    blank
}) => {

    return (
        <Container onClick={click} blank={blank}>
            <Icon src={icon} />
            <TitleContainer>
                <Subtitle>{subtitle}</Subtitle>
                <Title>{title}</Title>
            </TitleContainer>
        </Container>
    );
}

export {HomeMenuItem};